export const SORT_TYPES = {
  ascend: 'asc',
  descend: 'desc',
};

export const CONTRACT_MANAGEMENT_SORT_FIELDS = {
  employee_id: 'employee_id',
  full_name: 'full_name',
  contract_name: 'contract_name',
  start_date: 'start_date',
  end_date: 'end_date',
  status_contract: 'status_contract',
  contract_code: 'contract_code',
  status: 'status',
};

export const STATUS_CONTRACT = {
  APPROVED: 'approved',
  PENDING: 'pending',
  COMPLETED: 'completed',
  WAITING_FOR_CONFIRM: 'waiting for confirm',
  WAITING_FOR_HR_MANAGER: 'waiting for HR Manager',
  WAITING_FOR_EMPLOYEE: 'waiting for Employee',
  WAITING_FOR_CEO: 'waiting for CEO',
  REJECTED: 'rejected',
};
